import React from 'react';
import FeatureTab from '@ui-components/feature-tab';
import Layout from '@ui-components/layout';
import DirectDebitContainer from './directdebit';
import BankTransferContainer from './banktransfer';
import BankTransferContainerPSE from './banktransfer-pse';
import BankTransferContainerKhipu from './banktransfer-khipu';
import ClaimBankTransferContainer from './banktransfer-claim';
import language from '@language';
import { COUNTRIES, MANUAL_LINKS } from '@constants';
import './main.scss';

export default class Main extends React.Component<any, any> {
  topTabs: any;
  bottomTabs: any;
    constructor(props) {
        super(props);
        const { country } = this.props;

        switch (country) {
            case COUNTRIES.AR:
                this.topTabs = [
                    {
                        title: 'Transferencia',
                        subtitle: 'Pague a través de transferencia bancaria ',
                        icon: 'fa fa-refresh',
                        id: 'bank-transfer',
                        content: this.renderBankTransfer()
                    },
                    {
                        title:
                            'Realice el reclamo de su pago si ha realizado la transferencia sin haber enviado el formulario',
                        subtitle: '',
                        id: 'claim-bank-transfer',
                        icon: 'fa fa-question-circle',
                        className: 'claim-tab',
                        content: this.renderClaimBankTransfer()
                    }
                ];

                /*this.bottomTabs = [
                    {
                        title: 'Débito',
                        id: 'direct-debit',
                        subtitle: 'Debite desde su cuenta bancaria',
                        icon: 'fa fa-university',
                        content: this.renderDirectDebit.bind(this)
                    }
                ];*/

                this.bottomTabs = [];

                break;
            case COUNTRIES.CO:
                this.topTabs = [
                    {
                        title: 'Transferencia',
                        id: 'bank-transfer',
                        subtitle: 'Pague a través de transferencia bancaria ',
                        icon: 'fa fa-refresh',
                        content: this.renderBankTransfer.bind(this)
                    },
                    {
                        title:
                            'Realice el reclamo de su pago si ha realizado la transferencia sin haber enviado el formulario',
                        id: 'claim-bank-transfer',
                        subtitle: '',
                        icon: 'fa fa-question-circle',
                        className: 'claim-tab',
                        content: this.renderClaimBankTransfer.bind(this)
                    }
                ];
                this.bottomTabs = [
                    {
                        title: 'PSE',
                        subtitle: 'Pague a través de pagos en línea PSE',
                        id: 'pse',
                        icon: 'pse-icon',
                        content: this.renderPSETransfer.bind(this)
                    }
                ];

                break;
            case COUNTRIES.CL:
                this.topTabs = [
                    {
                        title: 'Transferencia',
                        subtitle: 'Pague a través de transferencia bancaria ',
                        id: 'bank-transfer',
                        icon: 'fa fa-refresh',
                        content: this.renderBankTransfer.bind(this)
                    },
                    {
                        title:
                            'Realice el reclamo de su pago si ha realizado la transferencia sin haber enviado el formulario',
                        subtitle: '',
                        id: 'claim-bank-transfer',
                        icon: 'fa fa-question-circle',
                        className: 'claim-tab',
                        content: this.renderClaimBankTransfer.bind(this)
                    }
                ];

                this.bottomTabs = []
                if(window.configByCountry.CL.khipu_integration) {
                  this.bottomTabs.push(
                      {
                          title: 'Khipu',
                          subtitle: 'Pague a través de pagos en línea Khipu',
                          id: 'khipu-bank-transfer',
                          icon: 'khipu-icon',
                          content: this.renderKhipuTransfer.bind(this)
                      }
                    );
                }

                break;
            case COUNTRIES.MA:
                this.topTabs = [
                    {
                        title: 'Virement bancaire',
                        subtitle: 'Payer par virement bancaire',
                        id: 'bank-transfer',
                        icon: 'fa fa-refresh',
                        content: this.renderBankTransfer.bind(this)
                    },
                    {
                        title:
                            'Faire une réclamation concernant votre virement en ligne',
                        subtitle: '',
                        id: 'claim-bank-transfer',
                        icon: 'fa fa-question-circle',
                        className: 'claim-tab',
                        content: this.renderClaimBankTransfer.bind(this)
                    }
                ];

                this.bottomTabs = [];

                break;
        }
    }

    renderDirectDebit() {
        const { country } = this.props;
        return <DirectDebitContainer country={country} />;
    }

    renderBankTransfer() {
        const { country } = this.props;
        return <BankTransferContainer country={country} />;
    }

    renderPSETransfer() {
        const { country } = this.props;
        return <BankTransferContainerPSE country={country} />;
    }

    renderKhipuTransfer() {
        const { country } = this.props;
        return <BankTransferContainerKhipu country={country} />;
    }
    renderClaimBankTransfer() {
        const { country } = this.props;
        return <ClaimBankTransferContainer country={country} />;
    }

    render() {
        const { country } = this.props;
        const { topTabs, bottomTabs } = this;
        return (
            <Layout title={language.payment_form} subtitle={language.payment_choice} country={country} manual={MANUAL_LINKS[country]}>
                {topTabs.length > 0 && (
                    <div className="payments-container">
                        <FeatureTab options={topTabs} />
                    </div>
                )}
                {bottomTabs.length > 0 && (
                    <div className="payments-container">
                        <FeatureTab options={bottomTabs} />
                    </div>
                )}
            </Layout>
        );
    }
}
